import { colors } from '../styles'

const Switch = {
  baseStyle: {
    track: {
      backgroundColor: colors.appGreyTwo,
      borderRadius: '13px',
      _checked: {
        bg: colors.appClearBlue,
      },
    },
    thumb: {
      backgroundColor: colors.appPaleGrey,
    },
  },
  sizes: {
    lg: {
      track: {
        p: '2px 4px',
      },
    },
    md: {
      track: {
        p: '2px 3px',
      },
    },
  },
  variants: {},
}

export default Switch
